import {SideNavigationMenuItemType} from '../types/SideNavigationTypes';
import React from 'react';

export interface SideNavigationMenuItemClickContextType {
    onMenuItemClick: (menuItem: SideNavigationMenuItemType, event: React.MouseEvent<HTMLAnchorElement> | undefined) => void;
}

const SideNavigationMenuItemClickContext = React.createContext<SideNavigationMenuItemClickContextType | undefined>(undefined);

export const useSideNavigationMenuItemClickContext = () => {
    const context = React.useContext(SideNavigationMenuItemClickContext);
    if (!context) {
        throw new Error('useSideNavigationMenuItemClickContext must be used within a SideNavigationMenuItemClickProvider');
    }
    return context;
};

export const SideNavigationMenuItemClickProvider = ({children, onMenuItemClick}: {
    children: React.ReactNode,
    onMenuItemClick: SideNavigationMenuItemClickContextType['onMenuItemClick']
}) => {
    return (
        <SideNavigationMenuItemClickContext.Provider value={{onMenuItemClick}}>
            {children}
        </SideNavigationMenuItemClickContext.Provider>
    );
};